import { Form } from "antd";
import { HeaderOverview, IRenderPieChart, RenderPieChart } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkData,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardFacilityUnit } from "service/dashboard/central/facility";

const COLORS = ["#276347", "#E5E5E5", "#F8931D", "#535A6E", "#8EC641"];

const FacilityTop = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const facilityTopDate = Form.useWatch("facilityTopDate");
  const date = findDate(facilityTopDate);

  const { data, isFetching, isError, error } = useGetDashboardFacilityUnit({
    ...date,
    property,
  });

  const findData = checkData(data);

  const dataPie: IRenderPieChart = {
    data: findData || [],
    dataKey: "count",
    dataName: "unitNumber",
    color: COLORS,
    text: t("times")
  };

  return (
    <WrapperBG>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("unit-top-5-facilities")}
          name="facilityTopDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="250px" />
        ) : !findData || findData.length <= 0 ? (
          <NoDataDashboard height="250px" />
        ) : (
          <RenderPieChart {...dataPie} />
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default FacilityTop;
